import Events from './Events'
import MediaQuery from './Modules/MediaQuery'

export default class Navbar {
    static OPEN_NAVBAR_CLASS = 'navbar--open'
    static BACKGROUND_LAYER_FRONT_CLASS = 'background-layer__front'
    static NAVBAR_TOUCHED_CLASS = 'navbar__item--touched'
    static NAVBAR_SELECTOR = '.js-navbar'
    static NAVBAR_ITEM_SELECTOR = '.js-navbar__item'
    static NAVBAR_LINK_SELECTOR = '.js-navbar__link'
    static NAVBAR_LEVEL2_SELECTOR = '.js-navbar__level-2'

    constructor() {
        this.navbar = document.querySelector(Navbar.NAVBAR_SELECTOR)
        this.items = document.querySelectorAll(Navbar.NAVBAR_ITEM_SELECTOR)
        this.initLinkControls()
        this.initNavbarListener()
    }

    initNavbarListener() {
        document.addEventListener(Events.CLICK_ON_BACKGROUND_LAYER_EVENT, () => {
            this.close()
        })
        document.addEventListener(Events.OPEN_NAVBAR_EVENT, () => {
            this.open()
        })
        document.addEventListener(Events.CLOSE_NAVBAR_EVENT, () => {
            this.close()
        })
    }

    open() {
        this.navbar.classList.add(Navbar.OPEN_NAVBAR_CLASS)
        this.navbar.classList.add(Navbar.BACKGROUND_LAYER_FRONT_CLASS)
    }

    close() {
        this.navbar.classList.remove(Navbar.OPEN_NAVBAR_CLASS)
        this.navbar.classList.remove(Navbar.BACKGROUND_LAYER_FRONT_CLASS)
    }

    initLinkControls() {
        for (const item of this.items) {
            const link = item.querySelector(Navbar.NAVBAR_LINK_SELECTOR)

            const level2 = item.querySelector(Navbar.NAVBAR_LEVEL2_SELECTOR)
            if (level2 === null) continue

            document.addEventListener('touchend', (event) => {
                this.removeTouchedClassIfItemIsNotTheEventTarget(item, event)
            })

            document.addEventListener('click', (event) => {
                this.removeTouchedClassIfItemIsNotTheEventTarget(item, event)
            })

            link.addEventListener('touchend', (event) => {
                this.linkClickBehaviour(item, event)
            })

            link.addEventListener('click', (event) => {
                this.linkClickBehaviour(item, event)
            })
        }
    }

    removeTouchedClassIfItemIsNotTheEventTarget(item, event) {
        if (!item.contains(event.target)) {
            item.classList.remove(Navbar.NAVBAR_TOUCHED_CLASS)
        }
    }

    linkClickBehaviour(item, event) {
        // screen is too big for mobile layout = default link behaviour
        if (MediaQuery.UpMd) return
        // item has the 'touched' class = second click = default link behaviour
        if (item.classList.contains(Navbar.NAVBAR_TOUCHED_CLASS)) return
        // item has not the 'touched' class = first click = prevent default and open submenu
        event.preventDefault()
        item.classList.add(Navbar.NAVBAR_TOUCHED_CLASS)
    }
}
